export const AVAILABLE_LANGUAGES = ['en', 'es', 'fr', 'de', 'it', 'pt', 'nl', 'sv'];
